export interface OrderItemServicesProperties {
  propertyCode: string;
  propertyValue: string;
}
